import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(prevStatus => ({ ...prevStatus, submitting: true }));

    // Client-side validation as backup
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'All fields are required.' }
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'Please enter a valid email address.' }
      });
      return;
    }

    try {
      // Use relative path for API endpoint that works in both development and production
      const apiUrl = window.location.hostname === 'localhost'
        ? 'http://localhost:3001/api/send-email' 
        : '/api/send-email';
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      if (response.ok) {
        setStatus({
          submitted: true,
          submitting: false,
          info: { error: false, msg: 'Message sent successfully!' }
        });
        setFormData({
          name: '',
          email: '',
          message: ''
        });
        setTimeout(() => {
          setStatus(prevStatus => ({ 
            ...prevStatus, 
            submitted: false, 
            info: { error: false, msg: null } 
          }));
        }, 3000);
      } else {
        throw new Error(data.message || 'Something went wrong');
      }
    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'Something went wrong. Please try again later.' }
      });
      console.error('Error sending email:', error);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="contact-name">Your name</label>
        <input
          id="contact-name"
          type="text"
          name="name"
          autoComplete="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="contact-email">Your email</label>
        <input
          id="contact-email"
          type="email"
          name="email"
          autoComplete="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="contact-message">What are you building?</label>
        <textarea
          id="contact-message"
          name="message"
          rows="5"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
      </div>

      <button
        type="submit"
        className="btn"
        disabled={status.submitting}
      >
        {status.submitting ? 'Sending...' : 'Send message'}
      </button>

      <div className={`form-status ${status.info.error ? 'error' : 'success'}`} role="status">
        {status.info.msg}
      </div>
    </form>
  );
};

export default ContactForm; 